import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { Port, Disruptions, MapData } from '../../model/marine-data.model';

@Component({
  selector: 'rc-port-details-modal',
  templateUrl: './port-details-modal.component.html',
  styleUrls: ['./port-details-modal.component.css']
})
export class PortDetailsModalComponent implements OnInit, OnChanges {
  @Input() port: Port | null = null;
  @Input() mapData: MapData | null = null;
  @Output() close = new EventEmitter<void>();

  portDisruptions: Disruptions[] = [];

  ngOnInit() {
    this.updatePortDisruptions();
  }

  ngOnChanges() {
    this.updatePortDisruptions();
  }

  private updatePortDisruptions() {
    if (this.port && this.mapData?.disruptions) {
      this.portDisruptions = this.mapData.disruptions.filter(d => 
        d.affected_ports?.includes(this.port!.id) || []
      );
    } else {
      this.portDisruptions = [];
    }
  }

  onClose() {
    this.close.emit();
  }

  getWeatherIcon(category: string): string {
    switch (category) {
      case 'WEATHER_DISRUPTION': return 'cloud';
      case 'PORT_CONGESTION': return 'ship';
      case 'ROUTE_DELAY': return 'clock';
      default: return 'alert-triangle';
    }
  }

  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}